__turbopack_context__.v({
  "barCta": "MobileStickyCtaBar-module__7NAtVa__barCta",
  "ctas": "MobileStickyCtaBar-module__7NAtVa__ctas",
  "layer": "MobileStickyCtaBar-module__7NAtVa__layer",
  "layerDarkFilled": "MobileStickyCtaBar-module__7NAtVa__layerDarkFilled",
  "layerDarkUnfilled": "MobileStickyCtaBar-module__7NAtVa__layerDarkUnfilled",
  "layerLight": "MobileStickyCtaBar-module__7NAtVa__layerLight",
  "layerLightFilled": "MobileStickyCtaBar-module__7NAtVa__layerLightFilled",
  "layerLightUnfilled": "MobileStickyCtaBar-module__7NAtVa__layerLightUnfilled",
  "note": "MobileStickyCtaBar-module__7NAtVa__note",
  "noteDark": "MobileStickyCtaBar-module__7NAtVa__noteDark",
  "noteLight": "MobileStickyCtaBar-module__7NAtVa__noteLight",
  "overlay": "MobileStickyCtaBar-module__7NAtVa__overlay",
  "productName": "MobileStickyCtaBar-module__7NAtVa__productName",
  "productNameDark": "MobileStickyCtaBar-module__7NAtVa__productNameDark",
  "productNameLight": "MobileStickyCtaBar-module__7NAtVa__productNameLight",
  "shell": "MobileStickyCtaBar-module__7NAtVa__shell",
});
